import Vue from "vue";

Vue.filter("yesNo", function(value) {
  return value ? "Yes" : "No";
});
